type SerializerFunction = (url: string) => string;
function vimeoSerializer(url: string, serializer: SerializerFunction): string {
  if (!url.includes('https://vimeo.com/')) {
    return serializer(url);
  }
  const embeddedUrl = url.replace('https://vimeo.com/', 'https://player.vimeo.com/video/');
  return `${embeddedUrl}`;
}

export function serialize(url: string): string {
  return vimeoSerializer(url, url => url);
}
